import { render } from "./NewOrderAssistance.vue?vue&type=template&id=388d1b92&scoped=true"
import script from "./NewOrderAssistance.vue?vue&type=script&lang=js"
export * from "./NewOrderAssistance.vue?vue&type=script&lang=js"

import "./NewOrderAssistance.vue?vue&type=style&index=0&id=388d1b92&lang=css"
import "./NewOrderAssistance.vue?vue&type=style&index=1&id=388d1b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388d1b92"]])

export default __exports__